<enquete-modal>
    <div id="{ props.modalId }" class="modal js-modal">
        <div class="modal__bg js-modal-close"></div>
        <div class="modal__content modal_filter">
            <div class="modal__content_inner">
                <h2 class="modal_title">chiyo-coご利用者アンケート</h2>
                <iframe id="enq_form" src="https://docs.google.com/forms/d/e/1FAIpQLSfdw8fYsN5he5bNnghwKoRU8hK7oTtq56qzhhdjPOvjcocm2w/viewform?usp=pp_url&entry.209766701={user_id}" width="100%" height="650" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます…</iframe>
                <button id="no_ans_bt" class="button button-primary" type="button" value="回答しない" onclick="{(e)=> no_enquete(e)}">回答しない</button>
            </div><!--/.modal__content_inner-->
            <a class="btn_close_modal js-modal-close" onclick="{ onClose }" style="cursor:pointer"><img src="/assets/img/common/icn_close_modal.svg" alt="閉じる"></a>
        </div><!--modal__content-->
    </div><!--modal-->
  <script>
    import di from "dependeny-injection";
    export default {
        user_id: '',
        onMounted() {
            this.user_id = di.userStatusApi.getUserId();
            this.update();
        },
        onClose(e) {
            window.$(this.$(`#${this.props.modalId}`)).fadeOut(100);
            setTimeout(()=> di.userStatusApi.fetch(), 1000);
            setTimeout(()=> di.userStatusApi.fetch(), 3000);
            setTimeout(()=> di.userStatusApi.fetch(), 5000);
            setTimeout(()=> di.userStatusApi.fetch(), 7000);
            setTimeout(()=> di.userStatusApi.fetch(), 9000);
        },
        async no_enquete(e) {
            if (confirm('今後同じアンケートを表示しませんがよろしいですか？')) {
                await di.userStatusApi.noEnquete();
                await di.userStatusApi.fetch();
                window.$(this.$(`#${this.props.modalId}`)).fadeOut(100);
            }
        }
    };
  </script>
  <style>
    iframe#enq_form{
        margin-bottom: 40px;
    }
  </style>
</enquete-modal>
